import { render } from "./AdminAddUpdateModal.vue?vue&type=template&id=78507dbc"
import script from "./AdminAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./AdminAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__